import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '@core/services/authentication.service';
import { PropertiesService } from '@core/services/properties.service';
import { RegisterService } from '@core/services/register.service';
import { StorageService } from '@core/services/storage.service';
import { UserService } from '@core/services/user.service';
import { AdminService } from '@shared/services/admin.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root'
})
export class SetupService {

  customizationData: any;

  constructor(
    private authenticationService: AuthenticationService,
    private injector: Injector,
    private adminService: AdminService,
    private registerService: RegisterService,
    private storageService: StorageService,
    private propertiesService: PropertiesService,
    private userService: UserService,
    private notificationService: NzNotificationService) {
  }


  parseUrlAuthenticationParam(url: any) {
    this.storageService.set('access_token', url?.searchParams.get('accessToken'));
    this.storageService.set('refresh_token', url?.searchParams.get('refreshToken'));
  }

  initialize(): Promise<void> {
    return new Promise((resolve) => {
      const router = this.injector.get(Router);
      const ssoUrl = new URL(window.location.href.replace('#', '?'));
      this.propertiesService.getProperties();
      if (this.authenticationService.hasToken()) {
        this.userService.getAuthenticatedUser().subscribe(() => {
          resolve();
        }, error => {
          if (error.status === 401 || (error.error && error.error.error === 'invalid_token')) {
            this.storageService.clear();
            if (this.propertiesService.PLAYGROUND) {
              router.navigateByUrl('/playground-register');
            } else {
              router.navigateByUrl('/login');
            }
            resolve();
          }
        });
      } else if (!this.authenticationService.hasToken() && this.propertiesService.SSO_URL === ssoUrl.pathname) {
        this.parseUrlAuthenticationParam(ssoUrl)
        this.userService.getAuthenticatedUser().subscribe(() => {
          router.navigateByUrl('/home');
          resolve();
        }, error => {
          if (error.status === 401 || (error.error && error.error.error === 'invalid_token')) {
            this.storageService.clear();
            if (this.propertiesService.PLAYGROUND) {
              router.navigateByUrl('/playground-register');
            } else {
              router.navigateByUrl('/login');
            }
            resolve();
          }
        });
      } else if (!this.authenticationService.hasToken() && !this.propertiesService.PLAYGROUND) {
        this.adminService.getCustomization().subscribe((res) => {
          this.customizationData = res;
        });
        this.registerService.isSetupCompleted().subscribe((response: { complete: boolean }) => {
          if (response.complete) {
            const token = ssoUrl?.searchParams.get('id_token');
            const data = {
              username: token,
              password: ''
            }

            delete data.password;

            if (!token) {
              if (ssoUrl?.searchParams.get('auth')==='false') {
                this.notificationService.error('Error', ssoUrl?.searchParams.get('message'));
              }
              router.navigateByUrl('/login');
            }

            if (token) {
              this.authenticationService.login(data).subscribe(res => {
                resolve();
              }, error => {
                router.navigateByUrl('/login');
                resolve();
                console.log('error while fetching session: ', error);
              });
            }
            resolve();
          } else {
            router.navigateByUrl('/register');
            resolve();
          }
        })
      } else if (this.propertiesService.PLAYGROUND) {
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');

        const authType = this.storageService.get('AUTH_TYPE');

        if (!code) {
          router.navigateByUrl('/playground-register');
        }

        this.userService.createUserWithCode(code, authType).subscribe(() => {
          this.authenticationService.login(this.propertiesService.demoCredentials).subscribe(res => {
            resolve();
          }, error => {
            router.navigateByUrl('/playground-register');
            resolve();
            console.log('error while fetching session: ', error);
          });
        }, error => {
          console.log('error while fetching createUserWithCode: ', error);
          router.navigateByUrl('/playground-register');
          resolve();
        });
      }
    });
  }

}
